export default __webpack_public_path__ + "static/media/addMany.88342835.svg";